import {
  lazyPipe,
  validateApiRequest,
  validateApiResponse,
  withApiErrorCapture,
} from '@musinsa/apis-common-api-zod4';
import { executeStandardRequest } from '@musinsa/packages-http';
import z from 'zod';
import { privateHttpClient } from '../httpClient';
import { createApiResponseSchema } from '../utils';
import { couponsApiPath } from './apiPath';

const PostCouponReceiveAllRequestSchema = z
  .object({
    shopTitle: z.string(),
  })
  .describe('PostCouponReceiveAllRequest');

export type PostCouponReceiveAllRequest = z.infer<typeof PostCouponReceiveAllRequestSchema>;

const CouponReceiveResultSchema = z.object({
  couponNo: z.number().int(),
  success: z.boolean(),
  errorCode: z.string().optional(),
  message: z.string().optional(),
});

const PostCouponReceiveAllDataSchema = z.object({
  totalCount: z.number().int().nonnegative(),
  successCount: z.number().int().nonnegative(),
  failedCount: z.number().int().nonnegative(),
  results: z.array(CouponReceiveResultSchema),
});

export const PostCouponReceiveAllResponseSchema = createApiResponseSchema(
  PostCouponReceiveAllDataSchema,
);
export type PostCouponReceiveAllResponse = z.infer<typeof PostCouponReceiveAllResponseSchema>;

export const postCouponReceiveAll = withApiErrorCapture(
  lazyPipe(
    validateApiRequest(PostCouponReceiveAllRequestSchema),
    async ({ shopTitle }: PostCouponReceiveAllRequest): Promise<PostCouponReceiveAllResponse> =>
      executeStandardRequest(() =>
        privateHttpClient.post<PostCouponReceiveAllResponse>(couponsApiPath.postCouponReceiveAll, {
          shopTitle,
        }),
      ),
    validateApiResponse(PostCouponReceiveAllResponseSchema),
  ),
);
